// let iview={}
import iView from 'iview';
import store from '@/store'
export default {
    oSuccess(){
        iView.Message.success('操作成功!');
    },
    uSuccess(){
        iView.Message.success('修改成功!');
    },
    aSuccess(){
        iView.Message.success('新增成功!');
    },
    dSuccess(){
        iView.Message.success('删除成功!');
    },
    tSuccess(){
      iView.Message.success("任务完成!");
    },
    oError(){
        iView.Message.error('操作失败!');
    },
    MError(){
        iView.Message.error('重复配置!');
    },
    uError(){
        iView.Message.error('修改失败!');
    },
    sError(){
        iView.Message.error('保存失败!');
    },
    aError(){
        iView.Message.error('新增失败!');
    },
    dError(){
        iView.Message.error('删除失败!');
    },
    nError() {
      iView.Message.error("网络不给力，请稍后重试。");
    },
    iError(){
      iView.Message.error("系统繁忙，请稍后重试。");
    },
    checkError(){
        iView.Message.error('提交的内容校验失败!');
    },
    uploadNumber(){
        iView.Message.warning('只能上传两张图片!');
    },
    saveSalePrice(){
        iView.Message.warning('请维护售价！');
    },
    saveSaleInventory(){
        iView.Message.warning('请维护商品的可售库存！');
    },
    pleaseCheck() {
        let config = {
            content: "请勾选后再操作!"
        }
        iView.Modal.warning(config);
    },
    checkRequired(){
        //iView.Message.error('必填项内容不能为空!');
        let config={
            title:"提示",
            content:"必填项内容不能为空!"
        }
        iView.Modal.warning(config);
    },
    checkRequired2(){
        //iView.Message.error('必填项内容不能为空!');
        let config={
            title:"提示",
            content:"建议零售价格不能为空!"
        }
        iView.Modal.warning(config);
    },
    operationSuccess(){
        iView.Message.success('操作成功!');
    },
    pleaseSelect(){
        let config={
            content:"请选择一条数据进行操作!"
        }
        iView.Modal.warning(config);
    },
    //文件上传时格式不符
    fileFormat(format){
        let config={
            title:"提示",
            content:"文件大小格式只能是"+format+"!<br/>请重新上传。"
        }
        iView.Modal.warning(config);
    },
    //上传时文件大小超过指定值
    exceededSize(siz){
        let config={
            title:"提示",
            content:"文件大小超过"+siz+"kb!<br/>请重新上传。"
        }
        iView.Modal.warning(config);
    },
    //请选择一条数据进行操作
    pleaseSelectOne(){
        let config={
            content:"请只选择一条数据进行操作!"
        }
        iView.Modal.warning(config);
    },
    //请选择一条数据进行操作
    isNotDelete(){
        return new Promise(function(resolve,reject){
            iView.Modal.confirm({
                title: '请确认',
                content: '<p>确认是否删除？</p>',
                onOk: () => {
                    resolve("ok")
                },
                onCancel: () => {
                    reject("cancel")
                }
            });
        })
    },
    //套餐管理删除按钮提示
    isPackageDelete(){
        return new Promise(function(resolve,reject){
            iView.Modal.confirm({
                title: '请确认',
                content: '<p>确定删除此套餐么？删除后套餐将下架并且删除！</p>',
                onOk: () => {
                    resolve("ok")
                },
                onCancel: () => {
                    reject("cancel")
                }
            });
        })
    },
    //包含非荣耀用户类型删除按钮提示
    isNotDeleteuserMana(){
        return new Promise(function(resolve,reject){
            iView.Modal.confirm({
                title: '请确认',
                content: '<p>包含非荣耀用户类型的账号，确认是否需要删除！</p>',
                onOk: () => {
                    resolve("ok")
                },
                onCancel: () => {
                    reject("cancel")
                }
            });
        })
    },
    //清空未保存数据时提示
    clearSave(){
        return new Promise(function(resolve,reject){
            iView.Modal.confirm({
                title: '有未保存的数据',
                content: '<p>继续操作将清空未保存的数据</p><p>是否继续？</p>',
                onOk: () => {
                    resolve("ok")
                },
                onCancel: () => {
                    reject("cancel")
                }
            });
        })
    },
    validateWarning(){
        iView.Message.warning('Check Pass but!');
    },
    //导出通用提示
    gotoExportQuery(vueSelf){
        return new Promise(function(resolve,reject){
            iView.Modal.confirm({
                title: '跳转提示',
                content: '<p>是否跳转到我的导出页面？</p>',
                onOk: () => {
                    let layoutTab=vueSelf.$store.state.base.layoutTabRef
                    layoutTab&&layoutTab.setActiveMenu&&layoutTab.setActiveMenu({path:"/systems/MyImportExport/ExportQuery"})
                    // vueSelf.$router.push("/systems/MyImportExport/ExportQuery")
                    resolve("ok")
                },
                onCancel: () => {
                    reject("cancel")
                }
            });
        })
    },
    //导入通用提示
    gotoImportQuery(vueSelf){
        return new Promise(function(resolve,reject){
            iView.Modal.confirm({
                title: '跳转提示',
                content: '<p>是否跳转到我的导入页面？</p>',
                onOk: () => {
                    let layoutTab=vueSelf.$store.state.base.layoutTabRef
                    layoutTab&&layoutTab.setActiveMenu&&layoutTab.setActiveMenu({path:"/systems/MyImportExport/ImportQuery"})
                    // vueSelf.$router.push("/systems/MyImportExport/ImportQuery")
                    resolve("ok")
                },
                onCancel: () => {
                    reject("cancel")
                }
            });
        })
    },
    //活动管理是否终止
    stopActivity(obj) {
        return new Promise(function (resolve, reject) {
            iView.Modal.confirm({
                title: obj.title||'',
                content: obj.content||'',
                onOk: obj.onOk||(() => {
                    resolve("ok")
                }),
                onCancel:obj.onCancel||(() => {
                    reject("cancel")
                })
            });
        })
    },
    //请选择审核通过的数据
    pleaseSelectAuditd(){
        let config={
            content:"请选择审核通过的数据进行操作!"
        }
        iView.Modal.warning(config);
    },
    //请选择符合条件的数据
    pleaseSelectEligible(){
        let config={
            content:"请选择符合条件的数据进行操作!"
        }
        iView.Modal.warning(config);
    },
    //请输入的价格符合条件的数据
    pleasemaxSelectEligible(){
        let config={
            content:"售价下限超过定价,请重新调整!"
        }
        iView.Modal.warning(config);
    },
    //请输入的价格符合条件的数据
    pleaseminSelectEligible(){
        let config={
            content:"售价上限低于定价,请重新调整!"
        }
        iView.Modal.warning(config);
    },
    //已推送成功的数据
    pleaseTuisongEligible(){
        let config={
            content:"已推送成功请勿重复操作!"
        }
        iView.Modal.warning(config);
    },
      //未推送的数据
      pleaseweiTuisongEligible(){
        let config={
            content:"未推送不允许修改!"
        }
        iView.Modal.warning(config);
    },
    //重复Sku编码
    pleaseSelectSkuEligible(){
        let config={
            content:"请不要输入重复Sku编码!"
        }
        iView.Modal.warning(config);
    },
    //无菜单权限。跳转到首页
    noPremGoHome(){
        let config={
            content:"很抱歉，你没有该页面权限，为您跳转到首页!"
        }
        iView.Modal.warning(config);
    },
    //店铺所属供应商和商品指定的供应商不匹配
    noBlend(){
        let config={
            content:"店铺所属供应商和商品指定的供应商不匹配!"
        }
        iView.Modal.warning(config);
    },
      //公共提示
      publicHints(type, title, content) {
        let config = {
            title: title,
            content: content
        }
        switch (type) {
            case "success":
                iView.Modal.success(config);
                break;
            case "warning":
                iView.Modal.warning(config);
                break;
            case "error":
                iView.Modal.error(config);
                break;
        }
    },
    message: myThrottle(showMessage)
}

function myThrottle(func, delay = 1500) {
    let lastTime = 0;
    return function(...args){
        const now = new Date().getTime();
        if (now - lastTime > delay) {
            lastTime = now;
            func.apply(this, args);
        }
    }
}

function showMessage(type, content){
    switch (type) {
        case "success":
            iView.Message.success(content);
            break;
        case "warning":
            iView.Message.warning(content);
            break;
        case "error":
            iView.Message.error(content);
            break;
    }
}


// WEBPACK FOOTER //
// ./src/utils/tips.js